/* global onDomChanged */
import $ from 'jquery'

//##################################
// Checkbox toggle behaviors
//   - data-checkbox-toggle
//        For when you want to conditionally show an element based on if checkbox is checked
//   - data-checkbox-toggle-inverse
//        Same as above, but shows when the checkbox is not checked, and hides when checked
//   - data-checkbox-toggle-disabled
//        For when you want to toggle the disabled attribute of some other element based on if checkbox is checked

// Helper function to trigger change only when not in an AJAX update
// This prevents infinite loops when forms with submit-on-change contain checkboxes with toggle behaviors
const triggerChangeIfNotAjaxUpdating = function ($element) {
  $element.each(function () {
    if (!window.Simplero?.state?.isAjaxUpdating) {
      $(this).change()
    }
  })
}

if (window.onDomChanged) {
  onDomChanged('input[type=checkbox][data-checkbox-toggle]', function () {
    const $this = this.change(function () {
      // We use attr here and not data, because data will try to interpret the value as JSON
      return $($(this).attr('data-checkbox-toggle')).formToggle(
        $(this).is(':checked')
      )
    })
    triggerChangeIfNotAjaxUpdating($this)
    return $this
  })

  onDomChanged(
    'input[type=checkbox][data-checkbox-toggle-inverse]',
    function () {
      const $this = this.change(function () {
        // We use attr here and not data, because data will try to interpret the value as JSON
        return $($(this).attr('data-checkbox-toggle-inverse')).formToggle(
          !$(this).is(':checked')
        )
      })
      triggerChangeIfNotAjaxUpdating($this)
      return $this
    }
  )

  // Disables when checkbox is unchecked
  onDomChanged(
    'input[type=checkbox][data-checkbox-toggle-disabled]',
    function () {
      const $this = this.change(function () {
        // We use attr here and not data, because data will try to interpret the value as JSON
        return $($(this).attr('data-checkbox-toggle-disabled')).attr(
          'disabled',
          !$(this).prop('checked')
        )
      })
      triggerChangeIfNotAjaxUpdating($this)
      return $this
    }
  )

  // Disables when checkbox is checked
  onDomChanged(
    'input[type=checkbox][data-checkbox-toggle-disabled-inverse]',
    function () {
      const $this = this.change(function () {
        // We use attr here and not data, because data will try to interpret the value as JSON
        return $($(this).attr('data-checkbox-toggle-disabled-inverse')).attr(
          'disabled',
          $(this).prop('checked')
        )
      })
      triggerChangeIfNotAjaxUpdating($this)
      return $this
    }
  )

  onDomChanged('input[type=checkbox][data-checkbox-toggle-force]', function () {
    const $this = this.change(function () {
      if ($(this).prop('checked')) {
        $($(this).attr('data-checkbox-toggle-force')).prop('checked', true)
      }
      // We use attr here and not data, because data will try to interpret the value as JSON
      return $($(this).attr('data-checkbox-toggle-force')).attr(
        'disabled',
        $(this).prop('checked')
      )
    })
    triggerChangeIfNotAjaxUpdating($this)
    return $this
  })
} else {
  console.error('onDomChanged not defined')
}
